import { useGlobalStore } from '../store'

import bindActions from '../store/bindActions'
import { CoreReducer, CoreSliceType } from '../store/core'
import { Fn } from 'depoto-core'
// import { Fn } from 'depoto-core/src/models'
import { setSelectedDate } from '../store/core/actions'

const { actions } = CoreReducer

type CoreHookReturnType = CoreSliceType & {
  setCore: Fn
  setCurrency: Fn
  setCarriers: Fn
  setCheckouts: Fn
  setSelectedCarrierId: Fn
  setSelectedCheckoutId: Fn
  setSelectedDetailCheckoutId: Fn
  setSelectedCountry: Fn
  setSelectedDepotId: Fn
  setCountries: Fn
  setDepots: Fn
  setVats: Fn
  setCurrencies: Fn
  setCompany: Fn
  setChildCompanies: Fn
  setSelectedChildCompany: Fn
  setCurrentOrder: Fn
  setOrdersHistory: Fn
  setOrderVouchers: Fn
  setIsStrictDepotFilter: Fn
  setAutoProcessStatusChange: Fn
  setOrderUpdates: Fn
  setPackageUpdates: Fn
  setGroupHistory: Fn
  setGroupSortProp: Fn
  setGroupSortDir: Fn
  setGroupFilterName: Fn
  setPayments: Fn
  setTags: Fn
  setSelectedTagId: Fn
  setSearchString: Fn
  setSearchType: Fn
  setItemCount: Fn
  setIsFetching: Fn
  setOrderReturns: Fn
  setSelectedDate: Fn
}
export const useCore = (): CoreHookReturnType => {
  const { state, dispatch } = useGlobalStore()
  const { core } = state
  const {
    setCore,
    setCurrency,
    setCarriers,
    setCheckouts,
    setSelectedCarrierId,
    setSelectedCheckoutId,
    setSelectedDetailCheckoutId,
    setSelectedCountry,
    setSelectedDepotId,
    setCountries,
    setDepots,
    setVats,
    setCurrencies,
    setCompany,
    setChildCompanies,
    setSelectedChildCompany,
    setCurrentOrder,
    setOrdersHistory,
    setOrderVouchers,
    setIsStrictDepotFilter,
    setAutoProcessStatusChange,
    setOrderUpdates,
    setPackageUpdates,
    setGroupHistory,
    setGroupSortProp,
    setGroupSortDir,
    setGroupFilterName,
    setPayments,
    setTags,
    setSelectedTagId,
    setSearchString,
    setSearchType,
    setItemCount,
    setIsFetching,
    setOrderReturns,
  } = actions
  const coreActions = bindActions(
    {
      setCore,
      setCurrency,
      setCarriers,
      setCheckouts,
      setSelectedCarrierId,
      setSelectedCheckoutId,
      setSelectedDetailCheckoutId,
      setSelectedCountry,
      setSelectedDepotId,
      setCountries,
      setDepots,
      setVats,
      setCurrencies,
      setCompany,
      setChildCompanies,
      setSelectedChildCompany,
      setCurrentOrder,
      setOrdersHistory,
      setOrderVouchers,
      setIsStrictDepotFilter,
      setAutoProcessStatusChange,
      setOrderUpdates,
      setPackageUpdates,
      setGroupHistory,
      setGroupSortProp,
      setGroupSortDir,
      setGroupFilterName,
      setPayments,
      setTags,
      setSelectedTagId,
      setSearchString,
      setSearchType,
      setItemCount,
      setSelectedDate,
      setIsFetching,
      setOrderReturns,
    },
    dispatch,
  )

  return { ...core, ...coreActions }
}
